export const VERIFY_GOOGLE_LOGIN_SUCCESS='VERIFY_GOOGLE_LOGIN_SUCCESS';
export const VERIFY_GOOGLE_LOGIN_ERROR='VERIFY_GOOGLE_LOGIN_ERROR';
export const TWOFA_VALIDATE_EMAIL_SUCCESS='TWOFA_VALIDATE_EMAIL_SUCCESS';
export const TWOFA_VALIDATE_EMAIL_ERROR='TWOFA_VALIDATE_EMAIL_ERROR';
export const TWOFA_LOGIN_TAC_SUCCESS='TWOFA_LOGIN_TAC_SUCCESS';
export const TWOFA_LOGIN_TAC_ERROR='TWOFA_LOGIN_TAC_ERROR';
export const LOGOUT='LOGOUT';


// WEBPACK FOOTER //
// ./src/redux/auth/actionTypes.js